var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgVpagDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1641,
    height: 416,
    viewBox: "0 0 1641 416",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1631.02 -132.692L966.493 532.323C885.61 613.226 754.719 613.226 674.171 532.323L9.31338 -132.692C-3.10446 -145.113 -3.10446 -165.59 9.31338 -178.011L321.773 -490.544C334.191 -502.965 354.663 -502.965 367.081 -490.544L994.685 137.208C1099.4 241.945 1278.28 167.757 1278.28 19.7144V-477.788C1278.28 -497.594 1302.11 -507.329 1316.21 -493.565L1631.69 -178.346C1644.1 -165.926 1644.1 -145.448 1631.69 -133.027",
    fill: "#201F1F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgVpagDark);
export default __webpack_public_path__ + "static/media/bg-vpag-dark.44776ba686dab81e70acf9460f75205e.svg";
export { ForwardRef as ReactComponent };